import createApi from 'store/utils/createApi';

export default createApi('/api/planos-de-saude-empresa')
